<template>
  <input
    ref="textInput"
    v-model="model"
    :type="type"
    :placeholder="placeholder"
    class="text-input"
    v-bind="inputListeners"
  />
</template>

<script>
/**
 * Generic text input that displays a label and error messages.
 */
export default {
  props: {
    /**
     * Model for the input.
     * @model
     */
    type: {
      type: String,
      default: 'text',
    },
    /**
     * Model for the input.
     * @model
     */
    modelValue: {
      type: String,
      default: null,
    },
    /**
     * Placeholder text of the input.
     */
    placeholder: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(val) {
        /**
         * Triggers model changes.
         *
         * @property {string} newValue new value for model
         */
        this.$emit('update:modelValue', val);
      },
    },
    inputListeners() {
      const { onInput, 'onUpdate:modelValue': updateModel, ...listeners } = this.$attrs;
      return listeners;
    },
  },
  watch: {
    focus: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            this.$refs.textInput.focus();
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="postcss" scoped>
.text-input {
  font-family: var(--font-main);
  align-items: center;
  border: 1px solid var(--border);
  border-radius: var(--round-corner-small);
  display: flex;
  flex-grow: 1;
  font-size: var(--font-size-16);
  padding: 0 var(--space-16);
  margin: 0;
  /* stylelint-disable plugin/no-unsupported-browser-features */
  appearance: none;
  /* stylelint-enable */

  &.invalid {
    border-color: var(--red) !important;
  }
}
</style>
